import Icon from "@react-native-vector-icons/material-design-icons/static";
import { StyleSheet } from "react-native";
import { Avatar, Card } from "react-native-paper";
import type { IconType } from "../../icon";
import { type AppTheme, useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import TooltipWrapper from "../TooltipWrapper";

const getStyles = (theme: AppTheme) =>
	StyleSheet.create({
		avatar: {
			backgroundColor: theme.colors.secondaryContainer,
			alignSelf: "center",
		},
	});
type CardHeaderAvatarProps = {
	icon: string;
};
type Props = {
	icon: string;
	title: string;
	subtitle: string;
	tooltip?: string;
	handleClickInfo?: (text: string) => void;
};
export const HeaderCardAvatar = ({ icon }: CardHeaderAvatarProps) => {
	const theme = useAppTheme();
	const styles = getStyles(theme);
	return (
		<Avatar.Icon
			style={styles.avatar}
			size={40}
			icon={(props) => <Icon name={icon as IconType} {...props} />}
			color={theme.palette.text.secondary}
		/>
	);
};
const HeaderCard = ({
	title,
	subtitle,
	icon,
	tooltip,
	handleClickInfo,
}: Props) => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();
	return (
		<Card.Title
			title={title}
			style={{
				paddingVertical: 16,
			}}
			titleVariant="titleMedium"
			subtitle={subtitle}
			subtitleVariant="bodySmall"
			subtitleNumberOfLines={2}
			left={() => <HeaderCardAvatar icon={icon} />}
			right={() =>
				tooltip ? (
					<TooltipWrapper title={tooltip}>
						<Icon
							color={theme.colors.onSurfaceVariant}
							style={{
								paddingRight: 16,
							}}
							onPress={
								isMobile && handleClickInfo
									? (e) => {
											e.stopPropagation();
											handleClickInfo(tooltip);
										}
									: undefined
							}
							name="information-outline"
							size={24}
							accessibilityLabel="information"
							accessible
						/>
					</TooltipWrapper>
				) : null
			}
		/>
	);
};
export default HeaderCard;
